import React from 'react';
import {  Input } from 'reactstrap';

const DefaultInput = ({type, value, name, id, placeholder}) => {
  return <Input type={type} value={value} name={name} id={id} placeholder={placeholder} className="form-input" disabled={true}/>
}

export default DefaultInput;